import { GridHelper } from 'components/Grids/GridHelper';
import {
  GeneralCellRenderer,
  NumberCellRenderer,
  BatchActionsCellRenderer
} from 'components/Grids/CellRenderers';

export default class BatchesColumnDefinitions {
  static createColDefs() {
    const columnDefs = [
      {
        headerName: 'Batch ID',
        field: 'batchId',
        cellRenderer: GeneralCellRenderer,
        minWidth: 70
      },
      {
        headerName: 'Upload Date',
        field: 'dateUploaded',
        cellRenderer: GeneralCellRenderer,
        valueGetter: ({
          data: { dateUploaded }
        }) => GridHelper.dateFormatter(dateUploaded, 'MMM DD, YYYY HH:mm:ss'),
        minWidth: 95,
        width: 145,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Status',
        field: 'statusString',
        cellRenderer: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Cover Sheet?',
        field: 'coverSheetJson',
        cellClass: 'center-aligned',
        valueGetter: ({
          data: { coverSheetJson }
        }) => (coverSheetJson ? 'Yes' : 'No'),
        minWidth: 120,
        width: 100,
        filter: false
      },
      {
        headerName: 'Number of Forms',
        field: 'numberOfForms',
        cellClass: 'center-aligned',
        cellRenderer: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: '% Forms Valid',
        field: 'percentageOfValidForms',
        cellClass: 'center-aligned',
        valueGetter: ({
          data: { percentageOfValidForms }
        }) => (percentageOfValidForms !== 'NaN' ? percentageOfValidForms : 'N/A'),
        cellRenderer: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Form Pages',
        field: 'numberOfFormPages',
        cellClass: 'center-aligned',
        cellRenderer: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Pages',
        field: 'numberOfPages',
        cellClass: 'center-aligned',
        cellRenderer: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Files',
        field: 'numberOfFiles',
        cellClass: 'center-aligned',
        cellRenderer: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'View / Action',
        cellClass: 'center-aligned form-action-btns',
        field: 'id',
        cellRenderer: BatchActionsCellRenderer,
        minWidth: 70,
        width: 135,
        filter: false
      }
    ];

    return columnDefs;
  }
}
